import { useState } from 'react';
import { BiUpload, BiDownload, BiFile, BiTable } from 'react-icons/bi';

const TipoImportacao = ({ onTipoSelecionado, onDownloadTemplate }) => {
    const [tipoSelecionado, setTipoSelecionado] = useState(null);

    const handleTipoChange = (tipo) => {
        setTipoSelecionado(tipo);
        onTipoSelecionado(tipo);
    };

    const downloadTemplate = () => {
        onDownloadTemplate(tipoSelecionado);
    };

    return (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 mb-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <BiUpload className="mr-2 text-blue-600" />
                Selecione o tipo de importação
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                {/* Opção XML */}
                <div
                    className={`border-2 rounded-lg p-4 cursor-pointer transition-all duration-200 ${tipoSelecionado === 'xml'
                            ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
                            : 'border-gray-300 dark:border-gray-600 hover:border-blue-400'
                        }`}
                    onClick={() => handleTipoChange('xml')}
                    data-tour-id="entrada:xml"
                >
                    <div className="flex items-center justify-center mb-3">
                        <BiFile className="w-12 h-12 text-blue-600" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white text-center mb-2">
                        Nota Fiscal XML
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
                        Importar dados diretamente de arquivos XML de notas fiscais eletrônicas
                    </p>
                    <div className="mt-3 text-center">
                        <span className="inline-block px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400 text-xs rounded-full">
                            Automático
                        </span>
                    </div>
                </div>

                {/* Opção Equipamentos */}
                <div
                    className={`border-2 rounded-lg p-4 cursor-pointer transition-all duration-200 ${tipoSelecionado === 'equipamentos'
                            ? 'border-green-500 bg-green-50 dark:bg-green-900/20'
                            : 'border-gray-300 dark:border-gray-600 hover:border-green-400'
                        }`}
                    onClick={() => handleTipoChange('equipamentos')}
                    data-tour-id="entrada:equipamentos"
                >
                    <div className="flex items-center justify-center mb-3">
                        <BiTable className="w-12 h-12 text-green-600" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white text-center mb-2">
                        Equipamentos
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
                        Importar equipamentos com nserie, nmac e netiqueta
                    </p>
                    <div className="mt-3 text-center">
                        <span className="inline-block px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400 text-xs rounded-full">
                            Equipamentos
                        </span>
                    </div>
                </div>
            </div>

            {/* Botão de download do template */}
            {tipoSelecionado === 'equipamentos' && (
                <div className="mt-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                    <div className="flex items-center justify-between">
                        <div>
                            <h4 className="font-medium text-gray-900 dark:text-white">
                                Template de Planilha
                            </h4>
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                Baixe o modelo de planilha para preenchimento de equipamentos
                            </p>
                        </div>
                        <button
                            onClick={downloadTemplate}
                            data-tour-id="entrada:template"
                            className="flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors duration-200"
                        >
                            <BiDownload className="mr-2" />
                            Baixar Template
                        </button>
                    </div>
                </div>
            )}

            {/* Instruções */}
            {tipoSelecionado && (
                <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                    <h4 className="font-medium text-blue-900 dark:text-blue-100 mb-2">
                        {tipoSelecionado === 'xml' ? 'Como usar XML:' : 'Como usar Excel (Equipamentos):'}
                    </h4>
                    {tipoSelecionado === 'xml' ? (
                        <ul className="text-sm text-blue-800 dark:text-blue-200 space-y-1">
                            <li>• Selecione um arquivo XML de nota fiscal eletrônica</li>
                            <li>• Os dados serão extraídos automaticamente</li>
                            <li>• Revise e classifique os produtos conforme necessário</li>
                        </ul>
                    ) : (
                        <ul className="text-sm text-blue-800 dark:text-blue-200 space-y-1">
                            <li>• Baixe o template de planilha de equipamentos</li>
                            <li>• Preencha com nserie, nmac e netiqueta</li>
                            <li>• Salve como arquivo Excel (.xlsx)</li>
                            <li>• Classifique marca, modelo, cliente e anexo</li>
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
};

export default TipoImportacao;
